import { useFiltersV2Actions } from "PFApp/components/filters_v2";
import { Button } from "PFComponents/button";
import React, { type Ref } from "react";

import css from "../filters_v2_container_with_show_more.module.scss";

type FiltersV2PreviewMoreButtonProps = {
  count: number;
  ref: Ref<HTMLDivElement | null>;
};

export const FiltersV2PreviewMoreButton = ({ count, ref }: FiltersV2PreviewMoreButtonProps) => {
  const { toggleFiltersSidePanel } = useFiltersV2Actions();

  if (count === 0) {
    return null;
  }

  return (
    <div ref={ref} className={css.showMoreButtonWrapper}>
      <Button kind="text" text={`+${count}`} onClick={() => toggleFiltersSidePanel(true)} />
    </div>
  );
};
